import '@/types/user';
import RestService from '../../contracts/RestService';
import { httpClient } from '../../utils/http-client';
export default class UsageService extends RestService {
    uri = 'usage';
    async getCredit() {
        return await (await httpClient.get(`${this.uri}/credit`)).data;
    }
}
